import { ProductAccommodation } from '@lx/shared/data-access/products';

export const noAccommodationOption: ProductAccommodation = {
  code: '',
  name: `Without accommodation`, //$localize only works inside a @Component, @Directive, @Injectable...
  weight: 0,
  productPosition: 0,
};
